import { BrandfolderHexColors } from '@brandfolder/react';
import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';

import { OAuthContext } from '@context/oauth';
import { PreviewContext } from '@context/preview';

import { HeaderBreadcrumbs } from './header-breadcrumbs';
import { HeaderDropdowns } from './header-dropdowns';
import { HeaderLoggedInAs } from './header-logged-in-as';
import { HeaderLogo } from './header-logo';
import { HeaderPreview } from './header-preview';
import { HeaderSupport } from './header-support';

interface HeaderProps extends HTMLAttributes<HTMLDivElement> {
  home?: boolean;
}

const UnstyledHeader: FunctionComponent<HeaderProps> = (props) => {
  const { home = false, ...otherProps } = props;

  const { authed } = useContext(OAuthContext);
  const { preview } = useContext(PreviewContext);

  if (!authed) return null;

  return (
    <header
      {...otherProps}
      className={classNames({
        header: true,
        'header--home': home,
        'header--preview': preview,
        [`${otherProps?.className}`]: !!otherProps?.className
      })}
    >
      <HeaderLogo />
      {preview && <HeaderPreview />}
      {!preview && (
        <>
          <HeaderBreadcrumbs home={home} />
          <HeaderDropdowns>
            <HeaderSupport />
            <HeaderLoggedInAs />
          </HeaderDropdowns>
        </>
      )}
    </header>
  );
};

const StyledHeader = styled(UnstyledHeader)`
  align-items: center;
  background-color: ${BrandfolderHexColors.White};
  display: grid;
  font-family: Circular-Book, sans-serif;
  grid-area: header;
  grid-template-columns: 40px minmax(0, 1fr) 260px;
  padding: 0 20px;

  &.header--preview {
    grid-template-columns: 40px minmax(0, 1fr);
  }
`;

export const Header: FunctionComponent<HeaderProps> = (props) => {
  return <StyledHeader {...props} />;
};
